<form>
  <!-- Modal Header -->
  <div class="modal-header" style="background-color: lightskyblue">
    <h4 class="modal-title">Manage Commission</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    <div class="card shadow mb-3">
      <div class="card-body">
        <table class="table-borderless">
          <tbody>
            @if (loan != undefined) {
              <tr>
                <td><strong>Customer Name</strong></td>
                <td>:</td>
                <td class="ps-2">{{ loan.CustomerName }}</td>
              </tr>
            }
            <tr></tr>
            <tr>
              <td><strong>Receipt Number</strong></td>
              <td>:</td>
              <td class="ps-2">{{ loan.ReceiptNumber }}</td>
            </tr>
            <tr>
              <td><strong>Principal</strong></td>
              <td>:</td>
              <td class="ps-2">RM {{ loan.Principal }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    @if (previousAssignedCommission < (commissionLimit / 100) * loan.Principal) {
      <!--Assignee-->
      @if (loanCommissionUserList.length > 0) {
        <mat-form-field>
          <mat-label>Assignee</mat-label>
          <select matNativeControl [(ngModel)]="assignee" name="assignee">
            @for (companyUsers of loanCommissionUserList; track companyUsers) {
              <optgroup [label]="companyUsers.companyCode">
                @for (user of companyUsers.usernameList; track user) {
                  <option [value]="user">
                    {{ user }}
                  </option>
                }
              </optgroup>
            }
          </select>
        </mat-form-field>
      }

      <!--Amount-->
      <div class="group mt-2">
        <input type="number" required class="textInputLong" name="amount" [(ngModel)]="amount" min="0" (keypress)="sharedService.isNumberKey($event)" />
        <span class="highlight"></span>
        <span class="bar barLong"></span>
        <label>Amount</label>
      </div>
      <span class="text-danger" [ngClass]="{ 'text-danger': sharedService.checkCommissionOverpay(loan, amount + previousAssignedCommission) == true, 'text-info': sharedService.checkCommissionOverpay(loan, amount + previousAssignedCommission) == false }" [hidden]="amount == undefined"
        ><strong
          >{{ (amount / loan.Principal) * 100 | number: "1.2-2" }}%
          @if (previousAssignedCommission != undefined) {
            <span>+ {{ (previousAssignedCommission / loan.Principal) * 100 | number: "1.2-2" }}% (Previous) = {{ ((previousAssignedCommission + amount) / loan.Principal) * 100 | number: "1.2-2" }}% </span>
          }
          of principal</strong
        ></span
      >

      <div class="d-flex justify-content-end">
        @if (sharedService.checkCommissionOverpay(loan, amount + previousAssignedCommission) == false) {
          <button class="btn btn-outline-success me-2" type="button" (click)="submit()" [disabled]="disabledSubmit">Assign Commission</button>
        }
        <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
      </div>
    } @else {
      <p class="fw-bold text-danger">Cannot assign commission anymore</p>
      <p class="fw-bold text-danger">Assigned : RM {{ previousAssignedCommission | number: "1.2-2" }} / Limit: RM {{ (commissionLimit / 100) * loan.Principal | number: "1.2-2" }}</p>
      <div class="d-flex justify-content-end">
        @if (previousAssignedCommission < sharedService.getMaxCommissionAmount(loan)) {
          <button class="btn btn-warning" (click)="openCommissionMessageModal()">Request Commission</button>
        }
      </div>
    }

    <div>
      <hr />

      <app-previous-assigned-commission [assignedCommisionList]="assignedCommisionList"></app-previous-assigned-commission>
    </div>
  </div>

  <!--
  <div class="modal-footer">

  </div> -->
</form>
